import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 44 44"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "22",
      cy: "22",
      r: "22",
      fill: "var(--status-svg-color)",
      "fill-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "none",
      stroke: "#fff",
      "stroke-width": "1.5",
      d: "M15 14h4v16h-4zM25 14h4v16h-4z"
    }, null, -1)
  ]))]))
}
export default { render: render }